// @ vendors
const { Promise } = require('es6-promise');
const { last } = require('lodash')

// @ commons
const { APIGet } = require('utilities/APIRequestHelper');

// @ constants
const {
    INSURANCE_REQUEST_OVERALL_VIEW_REQUEST,
    INSURANCE_REQUEST_OVERALL_VIEW_SUCCESS,
    INSURANCE_REQUEST_OVEARLL_VIEW_FAILURE,
    CLEAR_INSURANCE_REQUEST_OVERALL_VIEW
} = require('../../insuranceConstants/actionTypes');

const requestInsurancesOverallViewInProgress = () => ({
    type: INSURANCE_REQUEST_OVERALL_VIEW_REQUEST
});

const requestInsurancesOverallViewSuccess = data => ({
    type: INSURANCE_REQUEST_OVERALL_VIEW_SUCCESS,
    data
});

const requestInsurancesOverallViewFailure = error => ({
    type: INSURANCE_REQUEST_OVEARLL_VIEW_FAILURE,
    data: { error }
});

const requestClearInsurancesOverallView = () => ({
    type: CLEAR_INSURANCE_REQUEST_OVERALL_VIEW
});

const requestInsurancesOverallView = (policyNumber, policyVersion, filiationCode) => (dispatch, getState) => {
    const currentState = getState().insuranceRequestLanding;

    if (!currentState.get('isFetching')) {
        dispatch(requestInsurancesOverallViewInProgress());

        let requestData = {};
        if (policyNumber) {

            requestData = {
                query: {
                    "lastPolicy.policyNumber": policyNumber,
                    "lastPolicy.policyVersion": policyVersion,
                    "lastPolicy.filiationCode": filiationCode,
                }
            };
        } else {
            dispatch(requestClearInsurancesOverallView());
        }

        return APIGet({
            dispatch,
            endpoint: 'insurancesGetOverall',
            params: requestData
        })
            .then(response => {
                dispatch(requestInsurancesOverallViewSuccess(response.data));

                const { lastPage, policyInfo } = response.data;

                if (!lastPage && policyInfo.length > 0) {
                    const lastPolicy = last(policyInfo);
                    const { policyNumber, policyVersion, filiationCode } = lastPolicy;
                    requestInsurancesOverallView(policyNumber, policyVersion, filiationCode)(dispatch, getState);
                }
            })
            .catch(response => {
                if (!!response.error) {
                    dispatch(requestInsurancesOverallViewFailure(response.error));
                } else {
                    throw response;
                }
            });
    } else {
        return Promise.resolve();
    }
};

const clearInsurancesOverallView = () => dispatch => {
    dispatch(requestClearInsurancesOverallView());
};

module.exports = {
    requestInsurancesOverallView,
    clearInsurancesOverallView
};
